// Resize spacers on mobile
class blockSpacer {
    constructor(ref, height) {
        this.ref = ref;
        this.height = parseInt(height) || 0;
    }

    get preferedSize() {
        return window.innerWidth < 768 ? this.height / 2 : this.height;
    };

    cResizeSpacer() {
        let heightToSet = this.preferedSize;
        this.ref.style.height = `${heightToSet}px`;
    }
}

const allSpacers = [];

const wpSpacers = document.querySelectorAll('.wp-block-spacer');
wpSpacers?.forEach((el, key) => {
    allSpacers[key] = new blockSpacer(el, el.style.height);
});

function handleResize() {
    allSpacers?.forEach(obj => {
        obj.cResizeSpacer();
    })
}

handleResize();

window.addEventListener('resize', handleResize);